import Image from "@tiptap/extension-image";
import { RichTextEditor } from "@/components/rich-text/RichTextEditor";

const CidImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      "data-cid": { default: null },
    };
  },
});

export interface EmailComposerProps {
  value: string;
  onChange: (html: string) => void;
  disabled?: boolean;
  onUploadInlineImage?: (file: File) => Promise<{ cid: string; url: string }>;
}

export function EmailComposer({ value, onChange, disabled, onUploadInlineImage }: EmailComposerProps) {
  return (
    <RichTextEditor
      value={value}
      onChange={onChange}
      disabled={disabled}
      imageExtension={CidImage}
      onUploadImage={
        onUploadInlineImage
          ? async (file) => {
              const { cid, url } = await onUploadInlineImage(file);
              return { url, attrs: { "data-cid": cid } };
            }
          : undefined
      }
    />
  );
}
